import React, { useState } from "react";
import style from "../style/despesa.module.css";
import Input from "../components/Input";
import Button from "../components/Button";
import { useData } from "../function/method_desp_rec";
import {
  converterParaNumero,
} from "../function/funcionalidades";
import { Gasto } from "../model/gasto";
import Alert from "../components/Alert";
import Seletor from "../components/Seletor";
import Saldo from "../components/Saldo";

export default function CadastroDespesa() {
  const [nome, setNome] = useState("");
  const [valor, setValor] = useState("");
  const [mes, setMes] = useState("");
  const [modal,setModal] = useState(false);
  const [title,setTitle] = useState("")
  const [mensagem,setMensagem] = useState("")


  const { addGasto } = useData();

  const salvarDesp = (e) => {
    e.preventDefault();

    if (nome.trim() === "" || valor.trim() === "" || mes.trim() === "") {
      setModal(true)
      setTitle("Erro!")
      setMensagem("Por favor, preencha os campos!")
      return;
    }

    const valorConvert = converterParaNumero(valor);

    let gasto = new Gasto(nome, valorConvert, mes);
    addGasto(gasto);

    setNome("");
    setValor("");
    setMes("");
  };
  
  return (
    <>
     <Saldo />
      <section>
        <div className={style.form}>
          <div className={style.campo}>
            <label htmlFor="nome" className={style.label}>Nome</label>
            <Input
              id="nome"
              placeholder="Ex.: Televisão"
              valor={nome}
              inputMask={(text) => setNome(text)}
            />
          </div>
          {modal && <Alert
            isOpen={modal}
            title={title}
            mensagem={mensagem}
            setOpen={()=> setModal(false)}
          />}
          <div className={style.campo}>
            <label htmlFor="valor"  className={style.label}>Valor</label>
            <Input
              id="valor"
              mask="currency"
              placeholder="R$ 0,00"
              valor={valor}
              inputMask={(text) => setValor(text)}
            />
          </div>
          <div className={style.campo}>
            <label htmlFor="mes" className={style.label}>Mês</label>
            {/* <Input
              placeholder="Janeiro"
              valor={mes}
              inputMask={(text) => setMes(text)}
            /> */}
            <Seletor
              id="mes" 
              mes={mes}
              setMes={(setMes)}
            />
          </div>
          <div className={style.campo}>
            <Button title="Registrar" click={salvarDesp} />
          </div>
        </div>
      </section>
    </>
  );
}
